export const HOST_URL = ('development' === process.env.NODE_ENV) ? 'http://127.0.0.1:3030' : '';
export const API_URL = HOST_URL;
export const UPLOADS_URL = HOST_URL + '/uploads/';



// WEBPACK FOOTER //
// ./src/constants/index.js